// close modal on click
const roomModals = document.getElementById("room-modals");
if (roomModals) {
  roomModals.addEventListener("click", function (e) {
    roomModals.innerHTML = "";
  });
}

document.getElementById("hide_show_password").addEventListener("click", () => {
  const passwordField = document.getElementById("password");
  const passwordFieldType = passwordField.getAttribute("type");
  if (passwordFieldType === "password") {
    passwordField.setAttribute("type", "text");
    passwordField.focus();
  } else {
    passwordField.setAttribute("type", "password");
    passwordField.focus();
  }
});

document
  .querySelector(".close-become-a-roomie-modal")
  .addEventListener("click", function () {
    hideBecomeRoomieModal();
  });

document
  .querySelector(".modal-backdrop-become-a-roomie")
  .addEventListener("click", function (e) {
    if (e.target === this) {
      hideBecomeRoomieModal();
    }
  });

document
  .getElementById("become-a-roomie-form")
  .addEventListener("submit", function (e) {
    e.preventDefault();
    document.getElementById("modal-signup-button").disabled = true;
    const name = document.getElementById("name").value;
    const email = document.getElementById("email").value;
    const password = document.getElementById("password").value;
    const birthday = document.getElementById("birthday").value;
    document.getElementById("email").addEventListener("input", (e) => {
      // check if it has setCustomValidity and remove it if it has
      if (e.target.validity.customError) {
        e.target.setCustomValidity("");
      }
    });
    // Add your form submission logic here
    console.log(name, email, password, birthday);
    const apiUrl =
      window.location.hostname === "127.0.0.1"
        ? "http://localhost:8888"
        : "https://the-room-app.vercel.app";

    fetch(`${apiUrl}/api/becomeRoomie`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        name,
        email,
        password,
        birthday,
      }),
    })
      .then((response) => {
        if (response.ok) {
          document.getElementById("login_email").value = email;
          document.getElementById("login_password").value = password;
          document.getElementById("login_button").click();
        } else {
          document.getElementById("modal-signup-button").disabled = false;
          document
            .getElementById("email")
            .setCustomValidity("Email already exists");
          document.getElementById("email").reportValidity();
        }
      })
      .catch((error) => {
        // add custom input error message saying "Email already exists"
        console.error("Error:", error);
        document.getElementById("modal-signup-button").disabled = false;
        document
          .getElementById("email")
          .setCustomValidity("Email already in use. Try logging in.");
      });
  });

document.getElementById("birthday").addEventListener("keyup", (e) => {
  if (
    e.key === "Backspace" ||
    e.key === "Delete" ||
    e.key === "ArrowLeft" ||
    e.key === "ArrowRight" ||
    e.key === "Tab" ||
    e.key === "Enter"
  ) {
    return;
  }

  //if key was not a number ord a dash or slash, return

  const value = e.target.value;
  let valueWithOnlyNumbersAndSlashOrDash = value.replace(/[^0-9]/g, "");

  // if longer than 4 add -
  if (valueWithOnlyNumbersAndSlashOrDash.length > 4) {
    valueWithOnlyNumbersAndSlashOrDash =
      valueWithOnlyNumbersAndSlashOrDash.slice(0, 4) +
      "-" +
      valueWithOnlyNumbersAndSlashOrDash.slice(4);
  }

  // if longer than 7 add -
  if (valueWithOnlyNumbersAndSlashOrDash.length > 7) {
    valueWithOnlyNumbersAndSlashOrDash =
      valueWithOnlyNumbersAndSlashOrDash.slice(0, 7) +
      "-" +
      valueWithOnlyNumbersAndSlashOrDash.slice(7);
  }
  // if longer than 10 characters, remove the last character
  if (valueWithOnlyNumbersAndSlashOrDash.length > 10) {
    e.target.value = valueWithOnlyNumbersAndSlashOrDash.slice(0, 10);
    return;
  }
  let placeholder = "DD-MM-YYYY";
  placeholder = placeholder.slice(
    0,
    10 - valueWithOnlyNumbersAndSlashOrDash.length
  );
  e.target.value =
    valueWithOnlyNumbersAndSlashOrDash +
    placeholder.split("").reverse().join("");

  console.log(
    "valueWithOnlyNumbersAndSlashOrDash.length",
    valueWithOnlyNumbersAndSlashOrDash.length
  );
  if (valueWithOnlyNumbersAndSlashOrDash.length === 4) {
    e.target.setSelectionRange(
      valueWithOnlyNumbersAndSlashOrDash.length + 1,
      valueWithOnlyNumbersAndSlashOrDash.length + 1
    );
  } else {
    if (valueWithOnlyNumbersAndSlashOrDash.length === 7) {
      e.target.setSelectionRange(
        valueWithOnlyNumbersAndSlashOrDash.length + 1,
        valueWithOnlyNumbersAndSlashOrDash.length + 1
      );
    } else {
      e.target.setSelectionRange(
        valueWithOnlyNumbersAndSlashOrDash.length,
        valueWithOnlyNumbersAndSlashOrDash.length
      );
    }
  }
  return;
  // if (valueWithOnlyNumbersAndSlashOrDash.length === 4) {
  //   return (e.target.value = valueWithOnlyNumbersAndSlashOrDash += "-");
  // }

  // if (valueWithOnlyNumbersAndSlashOrDash.length === 7) {
  //   return (e.target.value = valueWithOnlyNumbersAndSlashOrDash += "-");
  // }
  // Format the value as YYYY/MM/DD
  const formattedValue = valueWithOnlyNumbersAndSlashOrDash.replace(
    /(\d{4})(\d{2})(\d{2})/,
    "$1-$2-$3"
  );
  e.target.value = formattedValue.replaceAll("/", "-");
});
